import TrainingCourseList from "./TrainingCourseList";

const TrainingCourseConfig = {
    settings: {
        layout: {
            config: {},
        },
    },
    routes: [
        {
            path: '/trainingCourseList',
            element: <TrainingCourseList />,
        },
    ],
}

export default TrainingCourseConfig;